import React from "react";
import CreateKCard from "../components/CreateKCard";

const CreatePage = function (props) {
  return (
    <CreateKCard
      inputLang={props.inputLang}
      outputLang={props.outputLang}
      updateLocalCollection={props.updateLocalCollection}
      collection={props.collection}
    />
  );
};

export default CreatePage;
